import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useAuth } from "../lib/auth";
import { LeadsTab, ConsultationsTab, AdStatsTab, SubscribersTab } from "../components/admin/Inbox";
import { BeforeAfterTab, BrandTab } from "../components/admin/Photos";
import { MembershipsTab } from "../components/admin/MembershipsAdmin";
import { BookingLinksTab } from "../components/admin/BookingLinksAdmin";

const TABS = [
  ["leads", "Leads", LeadsTab],
  ["consultations", "Consultations", ConsultationsTab],
  ["subscribers", "Skin Tips List", SubscribersTab],
  ["ads", "Ad Performance", AdStatsTab],
  ["before-after", "Before & After", BeforeAfterTab],
  ["brand", "Brand Photos", BrandTab],
  ["memberships", "Memberships", MembershipsTab],
  ["booking-links", "Booking Links", BookingLinksTab],
];

export default function Admin() {
  const { user, logout, check } = useAuth();
  const [checked, setChecked] = useState(user !== false);
  useEffect(() => {
    if (user === false && !checked) check().finally(() => setChecked(true));
  }, [user, checked, check]);
  if (user === null || (user === false && !checked)) return <div className="p-20 text-center kicker">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return (
    <main className="min-h-screen bg-[hsl(var(--stone))]" data-testid="admin-page">
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-8">
          <Link to="/" className="flex items-center gap-4" data-testid="admin-site-link"><img src="/logo-black.png" alt="Lux Veritae" className="h-14 w-auto" /><span className="kicker hidden sm:inline">Private Inbox</span></Link>
          <button onClick={logout} className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-neutral-700 hover:text-neutral-950" data-testid="admin-logout-btn"><LogOut size={14} strokeWidth={1.25} /> Sign out</button>
        </div>
      </header>
      <div className="mx-auto max-w-[1400px] px-5 py-12 md:px-8">
        <h1 className="font-display text-4xl font-light text-neutral-950 md:text-5xl">Welcome back.</h1>
        <Tabs defaultValue="leads" className="mt-10">
          <TabsList className="no-scrollbar h-auto w-full justify-start gap-1 overflow-x-auto rounded-none bg-transparent p-0">
            {TABS.map(([v, l]) => (
              <TabsTrigger key={v} value={v} className="rounded-none border border-transparent px-5 py-3 text-[11px] uppercase tracking-[0.2em] data-[state=active]:border-neutral-950 data-[state=active]:bg-white data-[state=active]:shadow-none" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([v, , C]) => (
            <TabsContent key={v} value={v} className="mt-8"><C /></TabsContent>
          ))}
        </Tabs>
      </div>
    </main>
  );
}
